import { textAreaKey } from './';
export var createTextAreaDriver = function (wrapper, idx) {
    if (idx === void 0) { idx = 0; }
    var base = wrapper.$$("." + textAreaKey).get(idx);
    return {
        value: function () { return base.value(); },
        set: function (value) { return base.enterValue(value); },
        disabled: function () { return base.hasClass('disabled'); },
        placeholder: function () { return base.attr('placeholder'); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map